import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import styles from './AutomaticBookingsModal.module.scss';

const AutomaticBookingsModal = ({ isOpen, onClose, onAccept, onDecline }) => {
  const isFeatureEnabled = false;

  if (!isFeatureEnabled) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className={styles.modal} overlayClassName={styles.overlay}>
      <div className={styles.content}>
        <h2>Automatic Booking now available</h2>
        <p>
          We&apos;ll automatically reserve your next session at the same day and time as your last one, so your preferred time stays locked in without
          needing to rebook manually.
          <br />
          <br />
          You&apos;ll always get a confirmation email, and if you need to reschedule, you can do it in one click. We&apos;ll use your updated time
          going forward.
          <br />
          <br />
          It&apos;s the easiest way to build a consistent learning rhythm, and that&apos;s the key to real progress with your language goals.
        </p>
        <div className={styles.buttons}>
          <button className={styles.acceptButton} onClick={onAccept}>
            Turn on Automatic Booking
          </button>
          <button className={styles.declineButton} onClick={onDecline}>
            No thanks
          </button>
        </div>
      </div>
    </Modal>
  );
};

AutomaticBookingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired
};

export default AutomaticBookingsModal;
